import { version } from '../../package.json';

export const APP_VERSION = version;
export const APP_PROJECT_NAME = 'PHOENIX';
